// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const azamtvColors: ColorType = {
  ...colorPalette,
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
  primary: '#7936DF',
  secondary: '#7936DF',
}

export const darkTheme = {
  colors: azamtvColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: azamtvColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: azamtvColors.primaryGray,
    secondary: azamtvColors.secondaryGray,
    disabled: azamtvColors.grayText,
    link: azamtvColors.secondaryGray,
    hint: azamtvColors.white,
    highlight: azamtvColors.secondary,
    gray: azamtvColors.primaryGray,
    seeAll: azamtvColors.secondaryGray,
    primaryContrast: '#ffffff',
  },
  border: {
    primary: azamtvColors.primaryGray,
    gray: azamtvColors.secondaryGray,
  },
  filter: {
    primary: azamtvColors.primaryGray,
    secondary: azamtvColors.secondaryGray,
    disabled: azamtvColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: azamtvColors.dark,
    color: azamtvColors.white,
    border: azamtvColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: azamtvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: azamtvColors.dark,
        selected: azamtvColors.dark,
        progress: rgba(azamtvColors.primary, 0.3),
        past: rgba(azamtvColors.primary, 0.3),
        pastSelected: azamtvColors.dark,
        pastHover: azamtvColors.dark,
        empty: '#555555',
        emptyProgress: rgba(azamtvColors.primary, 0.2),
      },
      text: {
        empty: azamtvColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: azamtvColors.white,
    subTitle: azamtvColors.secondaryGray,
    bg: azamtvColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {
    signLogoSize: 220,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
